import React from 'react';
import {Loading, Heading, Paragraph} from '@piggybank/core';

export const Load = ({showing, showText}) => (
  <div>
    <Loading
      show={showing ? true : false}
      getApplicationNode={() => document.getElementById('root')}>
      {showText ? (
        <Heading level={3}>{`Processing`}</Heading>
      ) : (
        <Heading level={3} style={{marginBottom: '-15px'}}>
          {`Loading`}
        </Heading>
      )}
      {showText ? (
        <Paragraph marginBottom={0}>
          {`Please don't refresh your browser or use the back button`}
        </Paragraph>
      ) : null}
    </Loading>
  </div>
);
export default Load;
